import React, { useState, useRef } from 'react'
import { TextField, makeStyles, Button, Typography } from '@material-ui/core'
import emailjs from '@emailjs/browser'

const useStyles = makeStyles(() => ({
    textInput: {
      '@media (min-width: 960px)': {
        width: '500px',
      },
      '@media (max-width: 960px)': {
        width: '90vw',
      },
        margin: '5px'
    },
    title: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    },
    description: {
        fontFamily: 'Helvetica, sans-serif',
        color: '#273746',
    }
}));

const FORM_ENDPOINT = ""; // TODO - fill on the later step

const FormContato = () => {
    const { textInput, title, description } = useStyles();
    const form = useRef();

  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(form);
    console.log(form.current);
    emailjs.sendForm('contato_MA_website', 'template_contato', form.current, 'yLXdRMDstme_y2jNr')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });

    setTimeout(() => {
      setSubmitted(true);
    }, 100);
  };

  if (submitted) {
    return (
      <>
        <Typography variant='h5' color='text.secondary' className={title}>
            Obrigado!
        </Typography>
        <Typography variant='body2' color='text.secondary' className={description}>
            Entraremos em contato em breve
        </Typography>
      </>
    );
  }

  return (
    <form
      action={FORM_ENDPOINT}
      onSubmit={handleSubmit}
      method="POST"
      target="_blank"
      style={{display: 'flex', flexDirection: 'column'}}
      ref={form}
    >
      <TextField className={textInput} id="outlined-basic" label="Nome completo" name="from_name" variant="outlined" required/>
      <TextField className={textInput} type="email" id="outlined-basic" label="Email" name="from_email" variant="outlined" required/>
      <TextField className={textInput} id="outlined-basic" label="Telefone" name="from_telephone" variant="outlined" />
      <TextField className={textInput} id="outlined-basic" label="Assunto" name="subject" variant="outlined" required/>
      <TextField className={textInput} id="outlined-basic" label="Mensagem" name="message" variant="outlined" multiline minRows={5} required/>
      <Button className={textInput} style={{backgroundColor: '#1F1A17', color: 'white'}}  variant="contained" onClick={e => handleSubmit(e)}>Enviar</Button>
    </form>
  );
};

export default FormContato;